export const SIZES = [3, 4, 5, 6, 7] as const;
export const INIT_SIZE = SIZES[0];
export const PLAYERS = ['0', 'X'] as const;
export const FIRST_PLAYER = PLAYERS[0];
export const THEMES = ['light', 'dark'] as const;
export const BASE_TRANSITION_DURATION = 400; // ms
